import DailyDeviationPage from './DailyDeviationPage';
import DailyDeviationPageContainer from './DailyDeviationPage.container';

export default DailyDeviationPageContainer(DailyDeviationPage);
